import React, { FC, useState } from 'react';
import cn from 'classnames';
import {Tooltip} from "antd";
import { LockerIcon } from '../../assets/svg';
import './styles.scss';

interface IWFPTabs {
  className?: string;
  selectedTab?: number;
  tabs: string[];
  disabledTabs?: string[];
  onTabSelect?: (type: string) => void;
  tabTooltip?: {
    [key: string]: string
  }
}

const WFPTabs: FC<IWFPTabs> = ({ className, selectedTab = 0, tabs, onTabSelect, disabledTabs, tabTooltip }) => {
  const [active, setActive] = useState<string>(tabs[selectedTab]);

  const onClickHandler = (tab: string): void => {

    if (!disabledTabs?.includes(tab)) {
      setActive(tab);
      onTabSelect?.(tab);
    }
  };

  return (
    <div className={cn('hbh-tab-container', className)}>
      {tabs?.map((tab: string, i: number) => (
        <button
          className={cn('hbh-tab-select', {
            ['hbh-tab-select__active']: active === tab,
          })}
          key={i}
          onClick={() => onClickHandler(tab)}
        >
          <Tooltip title={tabTooltip && tabTooltip[tab]}>
            {disabledTabs?.includes(tab) ? <div className='locked-tab'>
              <LockerIcon/>
              <span>{tab}</span>
            </div> : tab}
          </Tooltip>
        </button>
      ))}
    </div>
  );
};

export default WFPTabs;
